import {Component, ChangeDetectionStrategy, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';
import {environment} from '../environments/environment';
import {APP_VERSION} from './version';

@Component({
    selector: 'app-footer',
    template: `
        <div class="layout-footer clearfix">
            <a href="dashboard.xhtml">
                <img alt="logo-colored" src="assets/layout/images/logo-colored.png"/>
            </a>
            <span class="footer-text-right">
                <span class="mr-3" title="Frontend / Backend version">
                    FE {{ appVersion }}@if (apiVersion(); as be) {&nbsp;·&nbsp;BE {{ be }}}
                </span>
                <span>All Rights Reserved</span>
            </span>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppFooterComponent {
    private http = inject(HttpClient);

    appVersion = APP_VERSION;

    /** Backend version from the public /api/version endpoint; hidden while loading or unreachable. */
    readonly apiVersion = toSignal(this.http.get<{ version: string }>(environment.API_ENDPOINT + '/version').pipe(
        map(response => response.version),
        catchError(() => of(undefined))
    ));
}
